import React from 'react';
import {
  GroupLayout,
  LayoutProps,
  OwnPropsOfRenderer,
  UISchemaElement,
} from '@jsonforms/core';
import { Card } from 'antd';
import { LayoutRenderer } from '@components/uploadForm/renderers/views/layouts/LayoutRenderer';

export interface LayoutRendererProps extends OwnPropsOfRenderer {
  elements: UISchemaElement[];
  direction: 'row' | 'column';
}

const GroupComponent = React.memo(
  ({ visible, enabled, uischema, ...props }: LayoutRendererProps) => {
    const groupLayout = uischema as GroupLayout;
    return (
      <Card
        classNames={{
          header: '!border-0 !p-0 !pl-1.5 !min-h-0 mt-3 first:mt-4',
          body: '!p-0',
          title: 'text-1424 font-medium'
        }}
        hidden={!visible}
        title={groupLayout.label}
        className='bg-transparent shadow-none border-none'
      >
        <LayoutRenderer
          {...props}
          visible={visible}
          enabled={enabled}
          elements={groupLayout.elements}
          uischema={uischema}
          className="flex flex-col flex-wrap max-h-[140px]"
        />
      </Card>
    );
  }
);

export const GroupLayoutRenderer = ({
  uischema,
  schema,
  path,
  visible,
  enabled,
  renderers,
  cells,
}: LayoutProps) => {
  const groupLayout = uischema as GroupLayout;
  return (
    <GroupComponent
      elements={groupLayout.elements}
      schema={schema}
      path={path}
      visible={visible}
      enabled={enabled}
      uischema={uischema}
      renderers={renderers}
      cells={cells}
      direction="column"
    />
  );
};
